import { render, staticRenderFns } from "./queryNameDialog.vue?vue&type=template&id=37779123&scoped=true"
import script from "./queryNameDialog.vue?vue&type=script&lang=js"
export * from "./queryNameDialog.vue?vue&type=script&lang=js"
import style0 from "./queryNameDialog.vue?vue&type=style&index=0&id=37779123&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37779123",
  null
  
)

export default component.exports